/**
 * Removable chips for the currently selected error labels. Each chip shows the raw error label with
 * its RMA count and an "x" that removes the selection. Keyboard-operable.
 */
import { observer } from "mobx-react";
import IconClose from "../../../../../../components/icons/icon-close/icon-close";

interface IProps {
    selected: string[];
    getCount: (value: string) => number;
    disabled: boolean;
    onRemove: (value: string) => void;
}

const RmaListErrorsBucketChips: React.FC<IProps> = observer(({ selected, getCount, disabled, onRemove }) => {
    const handleRemove = (value: string) => {
        if (disabled) {
            return;
        }
        onRemove(value);
    };

    const handleKeyDown = (event: React.KeyboardEvent, value: string) => {
        if (disabled) {
            return;
        }
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            onRemove(value);
        }
    };

    return (
        <div className="rma-list-errors-bucket__chips">
            {selected.map((value) => (
                <div className="rma-list-errors-bucket__chip" key={value}>
                    <span className="rma-list-errors-bucket__chip-label">
                        {value} ({getCount(value)})
                    </span>
                    <span
                        role="button"
                        tabIndex={disabled ? -1 : 0}
                        className="rma-list-errors-bucket__chip-remove"
                        onClick={() => handleRemove(value)}
                        onKeyDown={(event) => handleKeyDown(event, value)}
                    >
                        <IconClose />
                    </span>
                </div>
            ))}
        </div>
    );
});

export default RmaListErrorsBucketChips;
